import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-47ddbe71")

_pushScopeId("data-v-47ddbe71")
const _hoisted_1 = { class: "historylist" }
const _hoisted_2 = { class: "historylist-sended-title-area" }
const _hoisted_3 = { class: "historylist-sended-title-area-title" }
const _hoisted_4 = { class: "commonTextBodyStrong historylist-sended-title-area-title-text" }
const _hoisted_5 = { class: "commonButtonText historylist-sended-title-area-more-button-text" }
const _hoisted_6 = { class: "historylist-sended-noelement-content" }
const _hoisted_7 = { class: "commonButtonText historylist-sended-noelement-content-button-text" }
const _hoisted_8 = { class: "historylist-viewed-title-area" }
const _hoisted_9 = { class: "historylist-viewed-title-area-title" }
const _hoisted_10 = { class: "commonTextBodyStrong historylist-viewed-title-area-title-text" }
const _hoisted_11 = { class: "commonButtonText historylist-viewed-title-area-more-button-text" }
const _hoisted_12 = { class: "historylist-viewed-noelement-content" }
const _hoisted_13 = { class: "historylist-viewed-noelement-content-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonHorizontalRecipeList = _resolveComponent("CommonHorizontalRecipeList")
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.sendedTitle), 1)
      ]),
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectDownloadList(...args))),
        class: "historylist-sended-title-area-more-button",
        style: _ctx.styleSendedMoreButton
      }, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.sendedMoreTitle), 1)
      ], 4)
    ]),
    _createVNode(_component_CommonHorizontalRecipeList, {
      class: "historylist-sended-area",
      recipes: _ctx.displaySendedList,
      limitCount: 10,
      style: _ctx.styleSendedList,
      onOnClick: _ctx.selectRecipe
    }, null, 8, ["recipes", "style", "onOnClick"]),
    _createVNode("div", {
      class: "historylist-sended-noelement",
      style: _ctx.styleSendedListNoElement
    }, [
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          innerHTML: _ctx.noDownloadElementText,
          class: "historylist-sended-noelement-content-text"
        }, null, 8, ["innerHTML"]),
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectRegisterDevice(...args))),
          class: "historylist-sended-noelement-content-button"
        }, [
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.registDeviceText), 1)
        ])
      ])
    ], 4),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("span", _hoisted_10, _toDisplayString(_ctx.viewedTitle), 1)
      ]),
      _createVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectDisplayedList(...args))),
        class: "historylist-viewed-title-area-more-button",
        style: _ctx.styleViewedMoreButton
      }, [
        _createVNode("span", _hoisted_11, _toDisplayString(_ctx.viewedMoreTitle), 1)
      ], 4)
    ]),
    _createVNode(_component_CommonRecipeList, {
      recipes: _ctx.displayViewedList,
      limitCount: 10,
      style: _ctx.styleViewedList,
      onSelectRecipe: _ctx.selectRecipe
    }, null, 8, ["recipes", "style", "onSelectRecipe"]),
    _createVNode("div", {
      class: "historylist-viewed-noelement",
      style: _ctx.styleViewedListNoElement
    }, [
      _createVNode("div", _hoisted_12, [
        _createVNode("span", _hoisted_13, _toDisplayString(_ctx.noViewedElementText), 1)
      ])
    ], 4)
  ]))
})